import { shuffleString } from './string';
const SPECIAL_CHARACTERS = '^$*.[]{}()?"!@#%&/\\,><\':;|_~`=+-'.split('');
export const generateRandomPassword = () => {
    const password = 
    // capital latin letters
    new Array(5)
        .fill('')
        .map(() => String.fromCharCode(Math.floor(Math.random() * 26) + 65))
        .join('') +
        // lowercase latin letters
        new Array(5)
            .fill('')
            .map(() => String.fromCharCode(Math.floor(Math.random() * 26) + 97))
            .join('') +
        // special characters
        new Array(2)
            .fill('')
            .map(() => SPECIAL_CHARACTERS[Math.floor(Math.random() * SPECIAL_CHARACTERS.length)])
            .join('') +
        // digits
        new Array(2)
            .fill('')
            .map(() => String.fromCharCode(Math.floor(Math.random() * 10) + 48))
            .join('');
    return shuffleString(password);
};
//# sourceMappingURL=password.js.map